import { createContext, useContext, useEffect, useState } from 'react';
import { Employee, Role } from '@momentum/types';
import { useAuth, useUser } from '@clerk/clerk-react';

export const EmployeeContext = createContext<Employee | undefined>(undefined);

export const EmployeeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [employee, setEmployee] = useState<Employee>();
  const { userId, isLoaded, orgRole, sessionClaims } = useAuth();
  const { user } = useUser();

  useEffect(() => {
    if (!isLoaded || !userId) return;

    setEmployee({
      _id: sessionClaims.metadata.userId,
      companyId: sessionClaims?.metadata.companyId,
      authProviderId: userId,
      personalInfo: {
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        imageUrl: user?.imageUrl || undefined,
      },
      workInfo: {
        email: sessionClaims.email as string,
      },
      isActive: true,
      role: orgRole as Role,
      metadata: {
        isDeleted: false,
        createdAt: new Date(1758363353647),
        lastUpdatedAt: new Date(1758363353647),
      },
    });
  }, [isLoaded, userId, sessionClaims, user, orgRole]);

  return (
    <EmployeeContext.Provider value={employee}>
      {children}
    </EmployeeContext.Provider>
  );
};

export const useEmployeeContext = () => {
  const context = useContext(EmployeeContext);

  if (context === undefined) {
    throw new Error('useEmployee must be used within an EmployeeProvider');
  }

  return context;
};
